var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33337 9.16667C5.3225 9.16667 7.23015 9.95685 8.63667 11.3634C10.0432 12.7699 10.8334 14.6775 10.8334 16.6667M3.33337 3.33334C6.86959 3.33334 10.261 4.73809 12.7615 7.23858C15.2619 9.73906 16.6667 13.1304 16.6667 16.6667M5.00004 15.8333C5.00004 16.2936 4.62694 16.6667 4.16671 16.6667C3.70647 16.6667 3.33337 16.2936 3.33337 15.8333C3.33337 15.3731 3.70647 15 4.16671 15C4.62694 15 5.00004 15.3731 5.00004 15.8333Z",
    stroke: "#DC6803",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveUpdate);
export default __webpack_public_path__ + "static/media/liveUpdate.68b13e8d4be667fae18538a6c58b55ac.svg";
export { ForwardRef as ReactComponent };